export interface UserConfig {
  showSms?:boolean,
  showVoice?:boolean,
  fixedIP?:boolean,
  showOrders?:boolean
}